import React from "react";
import {Container, Row, Col} from "react-bootstrap";
import {Link, useLocation} from "react-router-dom";
import {useDispatch} from "react-redux";
import {showSteps} from "actions/ui_control";
import {ytLinks} from "../../../utils/ytlinks";

const HeroSection = ({showVideo = true, additionalCol = <></>}) => {
  const dispatch = useDispatch();
  const showStepsFunc = () => {
    dispatch(showSteps());
  };

  const location = useLocation();
  // Get the iframe source based on the current path
  const pathKey = location.pathname.replace("/", "") || "homepage";
  const iframeSource = ytLinks[pathKey] || "";

  return (
    <section id="hero-section">
      <Container>
        <Row className="d-flex justify-content-center py-3">
          <Col sm={12} lg={8} className="text-center my-auto mb-lg-auto">
            <h1 className="mb-4 mt-4">
              Save Time. Your account. Your broker. Our systems. Multiple
              Markets.
            </h1>
            {/*<h3 className="mb-4">100% Free</h3>*/}
            <div className="button-container">
              <button
                onClick={showStepsFunc}
                style={{width: "153px", height: "48px"}}
                className="btn button-purple-gradient mb-2 me-2"
              >
                Try Demo
              </button>
              <Link to="/how-it-works">
                <button
                  style={{width: "153px", height: "48px"}}
                  className="btn button-purple-gradient mb-2 ms-2"
                >
                  How it works?
                </button>
              </Link>
            </div>

          </Col>
          {showVideo && (
            <Col sm={12} className="d-flex justify-content-center" style={{paddingTop: "30px"}}>
              <div className="ratio ratio-16x9 video-container">
                <iframe
                  src={iframeSource}
                  title={pathKey}
                ></iframe>
              </div>
            </Col>
          )}
          {additionalCol}
        </Row>
      </Container>
    </section>
  );
};

export default HeroSection;

// const HeroSection = ({showVideo = true, additionalCol = <></>}) => {
//   const dispatch = useDispatch();
//   const showStepsFunc = () => {
//     dispatch(showSteps());
//   };
//   return (
//     <section id="hero-section">
//       <Container>
//         <Row className="d-flex justify-content-center py-3">
//           <Col sm={12} lg={8} className="text-center my-auto mb-lg-auto">
//             <h1 className="mb-4 mt-4">
//               Save Time. Your account. Your broker. Our systems. Multiple
//               Markets.
//             </h1>
//             {/*<h3 className="mb-4">100% Free</h3>*/}
//             <div className="button-container">
//               <button
//                 onClick={showStepsFunc}
//                 style={{width: "153px", height: "48px"}}
//                 className="btn button-purple-gradient mb-2 me-2"
//               >
//                 Try Demo
//               </button>
//               <Link to="/how-it-works">
//                 <button
//                   style={{width: "153px", height: "48px"}}
//                   className="btn button-purple-gradient mb-2 ms-2"
//                 >
//                   How it works?
//                 </button>
//               </Link>
//             </div>
//           </Col>
//           {showVideo && (
//             <Col sm={12} className="d-flex justify-content-center">
//               {/* Currentl just an image as a holder, needs to be converted to an actual video */}
//               <div style={{paddingTop: "30px", borderRadius: "8px"}}>
//                 <iframe style={{border}} width="650" height="380"
//                         src="https://www.youtube.com/embed/Qctiujr7RnM?si=1re2_ec1VPBxxwEg"
//                   // title="YouTube video player"
//                         allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
//                         allowFullScreen>
//                 </iframe>
//               </div>
//               <img className="img-fluid" src={VideoScreen} alt=""/>
//             </Col>
//           )}
//           {additionalCol}
//         </Row>
//       </Container>
//     </section>
//   );
// };
//
// export default HeroSection;
